import { createContext, useContext, useEffect, useState } from "react";
import firebase from "../firebase";
import { toast } from "react-toastify";
import { saveNotificationsDeviceToken } from "../services/notifications";

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);
  const [isSwReady, setIsSwReady] = useState(false);

  useEffect(() => {
    checkPermissions();
  }, []);

  const checkPermissions = async () => {
    navigator.serviceWorker.ready.then(async (registration) => {
      // Obtener permiso para recibir notificaciones
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        throw new Error("Permiso para Notificaciones denegado");
      }

      // console.log("permiso: ", permission);
      // OBTENER TOKEN DE DISPOSITIVO
      const token = await firebase.messaging.getToken({
        // ESPERAR A QUE EL SW ESTE REGISTRADO Y ACTIVO
        serviceWorkerRegistration: registration,
      });
      // GUARDAR TOKEN EN LA BASE DE DATOS
      saveToken(token);
      // console.log(error);
    });
  };

  useEffect(() => {
    const unsubscribe = firebase.messaging.onMessage((payload) => {
      // console.log("Notificación recibida en primer plano:", payload);
      setNotification(payload.notification);
      toast.info(
        `${payload.notification.title}: ${payload.notification.body}`,
        {
          onClick: () =>
            window.open(
              "https://rym.mecaorg.com/panel/administracion/registroPagos"
            ),
        }
      );
    });

    return () => unsubscribe();
  }, []);

  const saveToken = async (token) => {
    try {
      const res = await saveNotificationsDeviceToken(token);
    } catch (error) {
      console.log("Error saving token: ", error);
    }
  };

  return (
    <NotificationContext.Provider value={{ notification }}>
      {children}
    </NotificationContext.Provider>
  );
};

export function useNotificationContext() {
  return useContext(NotificationContext);
}
